import { processComponentOption, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_580e16a0";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_580e16a0" };
/** script content **/
require("./sticky.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex580e16a0%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fsticky%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_580e16a0"],
    ctorType: "component",
    outputPath: "components/index580e16a0/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
